import { Injectable } from '@angular/core';

import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';


const USERS_PATH = '/users';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  loginState: Subject<any> = new Subject();

  _isAdmin = false;

  _authState: any = null;

  currentUser: any = null;

  constructor(private afAuth: AngularFireAuth,
    private http: HttpClient,
    private router: Router,
    private afStore: AngularFirestore,
    private afDb: AngularFireDatabase) {

    this.afAuth.authState.subscribe((auth) => {
      this._authState = auth;
      if(this._authState) {
        this.afStore.doc(`admins/${auth.uid}`).valueChanges().subscribe((data: any) => {
          if (data.role === 'superadmin' || data.role === 'schooladmin' || data.role === 'driveradmin') {
            this._isAdmin = true;
            this.currentUser = data;
            this.loginState.next({ status: 'OK', data });
          } else {
            this._isAdmin = false;
            this.loginState.next({ status: 'FAIL', message: 'You have no admin permission' });
            this.afAuth.auth.signOut();
          }
        });
      }
    });

  }

  login(email, password) {
    this.afAuth.auth.signInWithEmailAndPassword(email, password).then(user => {
      if (user) {
        
      }
    }).catch(err => {
      this._isAdmin = false;
      this.loginState.next({ status: 'FAIL', message: err.message });
    });
  }

  isAuthenticated() {
    return this._isAdmin && this._authState != null;
  }

  signOut() {
    this.afAuth.auth.signOut();
    this._isAdmin = false;
    this._authState = null;
    this.router.navigate(['/login']);
  }

}
